<template>

    <fragment v-if="( ( ! addopinion && ! loading ) || ( addopinion ) )">

        <div ref="imagecomponent" class="wrapper" v-on:mousewheel="wheel_handler" v-on:mouseup="drop($event)">

            <div class="image-wrapper">

                <img
                    v-on:mouseup="mouseup_handler($event, slide)"
                    v-on:mousedown="mousedown_handler($event,slide)"
                    v-on:pointerup="pointerup_handler"
                    v-on:pointerdown="pointerdown_handler"
                    v-on:pointermove="pointermove_handler"
                    v-on:pointercancel="pointerup_handler"
                    v-on:pointerout="pointerup_handler"
                    v-on:pointerleave="pointerup_handler"
                    v-touch:start="touchStart"
                    v-touch:end="touchEnd(slide)"
                    :alt="slide.title"
                    class="image-type-slide" :src="'/images/projects/' + getImageSrc(slide.assets, 'scaled')" 
                >

                <img
                    :src="getPinImage(m)"
                    class="pin"
                    alt="nål"
                    :class="hidePinClass(m)"
                    :v-if="dataStore.collectedAnswers.length && ! dataStore.showHeatMap"
                    :style="pinStyle(m)"
                    v-on:mousedown="addopinion ? pickup(m, $event, true) : false"
                    v-on:touchstart="addopinion ? pickup(m, $event, false) : false"
                    v-on:mouseup="addopinion ? drop($event) : false"
                    v-on:touchend="addopinion ? drop($event) : false"
                    v-for="(m, markerindex) in dataStore.collectedAnswers.filter(item => item.item_id === slide.id)"
                    :key="markerindex"
                    :data-id="m.id"
                    v-on:click="toggleOpinion(m)"
                    v-touch:tap="toggleEventTouchOnPin({
                        slide,m,markerindex,addopinion
                    })"
                >
                <!-- https://github.com/jerrybendy/vue-touch-events -->

            </div>

        </div>

    </fragment>

</template>

<script>

import dataStore from "../../store";

import { Fragment } from 'vue-fragment'

import { markerObject, hideHint, addAnswer, toggleOpinionForm, getItem, clickOutside } from '../../functions'

import { repositionImage, zoomIn, zoomOut, getImageSrc } from '../../image-functions'

export default {

    inject: [ 'loading' ],

    data() {

        return {

            dataStore: dataStore,

            imageMarkerPosX: null,

            imageMarkerPosY: null,

            threshold : 5,

            cursorPosition : {

                clientX: 0,

                clientY: 0

            },

            eCache : [],

            prevDiff : -1,

            directionY : 0,

            directionX : 0,

            getImageSrc,

            clickOutside

        };
    },

    components : {
        Fragment,
    },

    computed: {

        triggerRepositionImage: function() {
            return this.dataStore.currentSlide && this.dataStore.currentSlide.type === 'image' && this.dataStore.currentSlide.question && this.dataStore.currentSlide.question.type === 'goodbad'
        }

    },

    props: {
        slide : Object,
        project : Object,
        slides : Array,
        index : Number,
        getPinImage : Function,
        addopinion: Boolean,
        slug : String,
        componentKey : Number,
    },

    watch: {

        componentKey: function(newVal, oldVal) {

            if( this.triggerRepositionImage ) {
                repositionImage()
            }

        }

    },

    mounted() {

        $('.wrapper').kinetic({
            cursor: 'auto',
            filterTarget: function (target, e) {
                if (!/down|start/.test(e.type)) {
                    return !(/div/i.test(target.tagName));
                }
            }
        })

        this.$nextTick(() => {

            if( this.triggerRepositionImage ) {
                repositionImage()
            }
        })

    },

    methods: {

        hidePinClass: function(m) {

            if(this.multi && this.multi != 'null') {

                let multi = JSON.parse(m.multi);

                if(Array.isArray(multi)) {
                    let first = multi.shift();
                    if(first !== m.id) {
                        return 'hide'
                    }
                }
            }

            return ''

        },

        toggleOpinion: function(marker) {
            this.eventOpenPopup()
            toggleOpinionForm(marker);
        },

        runKinetic: function() {
            $('.wrapper').kinetic('attach');
        },

        removeKinetic: function() {
            $('.wrapper').kinetic('detach');
        },

        drop: function(e) {

            if(this.dataStore.movingPin) {
                if(this.dataStore.movingPin.lng < 0 || this.dataStore.movingPin.lng > 100 || this.dataStore.movingPin.lat < 0 || this.dataStore.movingPin.lat > 100) {
                    this.dataStore.movingPin.lng = 50
                    this.dataStore.movingPin.lat = 50
                }
            }

            this.dataStore.movingPin = null;
            this.dataStore.justMovedPin = false

            document.removeEventListener('mousemove', this.move)
            document.removeEventListener('touchmove', this.move)
            this.runKinetic()
        },

        getPosition(image, clientX, clientY) {

            let wrapperOffset = $('.slick-active .image-wrapper').offset();
            let topPos = $('.slick-active .image-type-slide').scrollTop() + clientY - wrapperOffset.top
            let leftPos = $('.slick-active .image-type-slide').scrollLeft() + clientX - wrapperOffset.left
            let posY = ( (topPos - this.dataStore.movingPin.diffY) / image.height() ) * 100
            let posX = ((leftPos - this.dataStore.movingPin.diffX) / image.width()) * 100

            return {
                posX : posX,
                posY : posY
            }

        },

        pickup: function(m, event, isDesktop) {

            let pinTop = $(event.target).offset().top;
            let pinLeft = $(event.target).offset().left;
            let clientY = event.clientY;
            let clientX = event.clientX;
            let heightPin = $(event.target).height()
            let widthtPin = $(event.target).width()

            m.diffY = isDesktop ? Math.abs(pinTop - clientY ) - (heightPin / 2) : 0;
            m.diffX = isDesktop ? Math.abs(pinLeft - clientX ) - (widthtPin / 2) : 0;

            this.dataStore.movingPin = m;

            document.addEventListener('mousemove', this.move)
            document.addEventListener('touchmove', this.move)
        },

        move: function(e) {

            let image = $('.slick-active img.image-type-slide')

            if (this.dataStore.movingPin) {

                this.removeKinetic()

                let positions, directionHor, directionVert;

                if (e.clientX) {
                    positions = this.getPosition(image, e.clientX, e.clientY)
                } else {
                    positions = this.getPosition(image, e.changedTouches[0].clientX, e.changedTouches[0].clientY)
                }

                if (e.clientX < this.directionX) {
                    directionHor = "left"
                } else if (e.clientX > this.directionX) {
                    directionHor = "right"
                }

                this.directionX = e.clientX;

                if (e.clientY < this.directionY) {
                    directionVert = "up"
                } else if (e.clientY > this.directionY) {
                    directionVert = "down"
                }

                this.directionY = e.clientY;

                if( (directionHor === 'right' || directionHor === undefined) && positions.posX > 100 ) {
                    this.dataStore.movingPin.lng = 50
                    this.dataStore.movingPin.lat = 50
                    return;
                }
                else if( (directionHor === 'left' || directionHor === undefined) && positions.posX < 0 ) {
                    this.dataStore.movingPin.lng = 50
                    this.dataStore.movingPin.lat = 50
                    return;
                }
                else if( (directionVert === 'up' || directionVert === undefined) && positions.posY < 0) {
                    this.dataStore.movingPin.lng = 50
                    this.dataStore.movingPin.lat = 50
                    return;
                }
                else if( (directionVert === 'down' || directionVert === undefined) && positions.posY > 100 ) {
                    this.dataStore.movingPin.lng = 50
                    this.dataStore.movingPin.lat = 50
                    return;
                }

                else {
                    this.dataStore.movingPin.lng = positions.posX
                    this.dataStore.movingPin.lat = positions.posY
                }

                this.dataStore.justMovedPin = true;
            }
        },

        toggleEventTouchOnPin: function(obj){

            return (e) => {

                if(e.type === 'touchend'){

                    const answerID = e.target.dataset.id

                    const found = this.dataStore.collectedAnswers.find(item => item.id == answerID )

                    this.eventOpenPopup()

                    toggleOpinionForm(found)
                }
            }
        },

        press(clientX, clientY) {
            this.cursorPosition.clientX = clientX;
            this.cursorPosition.clientY = clientY;
        },

        release(clientX, clientY, e, slide) {

            if(this.dataStore.movingPin) {
                this.dataStore.movingPin = null;
            }

            let image = $(e.target);

            if ((this.cursorPosition.clientX > clientX - this.threshold && this.cursorPosition.clientX < clientX + this.threshold) && (this.cursorPosition.clientY > clientY - this.threshold && this.cursorPosition.clientY < clientY + this.threshold)) {
                let offset = $('.slick-active .image-wrapper').offset();
                // Calculate marker position
                let posX = (($('.slick-active .image-type-slide').scrollLeft() + clientX - offset.left) / image.width()) * 100;
                // 19 is half of 38 which is the height of the pin, its not rendered yet, so need to put it in here for now
                let posY = (($('.slick-active .image-type-slide').scrollTop() + clientY - offset.top - 19) / image.height()) * 100;

                if(this.addopinion === true){
                    this.addMarker(parseFloat(slide.id), posX, posY)
                }


            }
            else {
                e.preventDefault();
            }
        },

        touchStart(e) {

            if(e.type === 'touchstart'){
                if (e.changedTouches.length === 1) {
                    this.press(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                }
            }
        },

        touchEnd(slide) {
            return (e) => {
                if(e.type === 'touchend'){
                    if (e.changedTouches.length === 1) {
                        this.release(e.changedTouches[0].clientX, e.changedTouches[0].clientY, e, slide);
                    }
                }
            }
        },

        wheel_handler(e) {

            if(this.dataStore.viewActive.heatmap) {
                [...document.getElementsByClassName("heatmap-canvas")].forEach((e) => e.remove());
                clearTimeout(this.dataStore.heatMapDataPointsTimoutDebounce)
            }

            if (e.wheelDelta >= 0) {
                zoomIn(true);
            }
            else {
                zoomOut(true);
            }
        },

        pointerdown_handler(e) {
            // The pointerdown event signals the start of a touch interaction
            this.eCache.push(e);
        },

        pointermove_handler(e) {

            // Find this event in the cache and update its record with this event
            for (var i = 0; i < this.eCache.length; i++) {
                if (e.pointerId == this.eCache[i].pointerId) {

                    this.eCache[i] = e;
                    break;
                }
            }

            // If two pointers are down, check for pinch gestures
            if (this.eCache.length == 2) {
                // Calculate the distance between the two pointers
                var curDiff = Math.abs(this.eCache[0].clientX - this.eCache[1].clientX);

                if (this.prevDiff > 0) {
                    if (curDiff > this.prevDiff) {
                        // The distance between the two pointers has increased
                        zoomIn(false);
                    }
                    if (curDiff < this.prevDiff) {
                        // The distance between the two pointers has decreased
                        zoomOut(false);
                    }
                }

                // Cache the distance for the next move event
                this.prevDiff = curDiff;
            }
        },

        pointerup_handler(e) {
            // Remove this pointer from the cache and reset the target's
            // background and border
            this.remove_event(e);

            $('.slick-active body').css('background-color', 'white');

            // If the number of pointers down is less than two then reset diff tracker
            if (this.eCache.length < 2) {
                this.prevDiff = -1;
            }
        },

        mousedown_handler(e) {
            this.press(e.clientX, e.clientY);
        },

        mouseup_handler(e, slide) {
            this.release(e.clientX, e.clientY, e, slide);
        },

        remove_event(e) {
            // Remove this event from the target's cache
            for (var i = 0; i < this.eCache.length; i++) {
                if (this.eCache[i].pointerId == e.pointerId) {
                    this.eCache.splice(i, 1);
                    break;
                }
            }
        },

        pinStyle (marker) {
            return `position: absolute; left: ${marker.lng}%; top: ${marker.lat}%; transform: translate(-50%,-50%); width: 30px; height: 38px;`
        },

        eventOpenPopup: function() {

            const eventOpenPopup = new CustomEvent('eventOpenPopup', {

                detail: {
                    type : 'IMAGE', // image / map
                    state : this.dataStore.infoWinOpen ? 'ADD' : 'VIEW',   // 'ADD' : 'VIEW'
                    addopinion : this.addopinion, // addopinion
                    slide : this.slide,// slide
                    project : this.project, // project
                    index : this.index // index
                }
            })

            document.dispatchEvent(eventOpenPopup);

        },

        addMarker: function(slideID, posX, posY) {

            const alreadyInBag = this.dataStore.collectedAnswers.filter(item => item.item_id === this.slide.id)
            // only allow to answer a certain amount answers - change in admin
            if(alreadyInBag.length == this.slide.amount_of_answers && this.slide.question && this.slide.question.limit_markers) return

            if(this.dataStore.infoWinOpen) return;

            hideHint(this.slug, slideID);

            // gets item/slide
            let slide = getItem(this.slides,slideID);

            let marker = markerObject(parseFloat(posY), parseFloat(posX), slide.id, slide.question);

            // //opens popupform
            toggleOpinionForm(marker).then(() => this.eventOpenPopup() )

            // //adds marker to collection
            addAnswer(marker);
        },




    }
};
</script>

